import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	screenReaderSearchResult: {
		id: 'users-and-roles.screen-reader-search-result',
		defaultMessage:
			"{count, plural, =0 {We couldn't find anyone matching your search.} =1 {1 user or group matches your search.} other {# users or groups match your search.}}",
		description:
			'This message is for screen reader on search results only when result is within one page for pagination.',
	},
	screenReaderSearchResultMoreThanOnePage: {
		id: 'users-and-roles.screen-reader-search-result-more-than-one-page',
		defaultMessage:
			'More than {count, plural, =1 {1 user or group matches your search.} other {# users or groups match your search.}}',
		description:
			'This message is for screen reader on search results only when result is more than one page for pagination.',
	},
});

export default messages;
